import { atom } from 'recoil';
import { CaregilityServiceAdapter } from '@adapters';

export const AdapterAtom = atom<CaregilityServiceAdapter | null>({
  key: 'AdapterAtom',
  default: null,
  dangerouslyAllowMutability: true,
});
